module.exports = __webpack_public_path__ + "img/8.bea02743.jpg";